import { render, staticRenderFns } from "./SmartTable.vue?vue&type=template&id=633c19b8&scoped=true"
import script from "./SmartTable.vue?vue&type=script&lang=js"
export * from "./SmartTable.vue?vue&type=script&lang=js"
import style0 from "./SmartTable.vue?vue&type=style&index=0&id=633c19b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c19b8",
  null
  
)

export default component.exports